import axios from 'axios'
import { REACT_APP_API } from 'cfgCommon/config'

/**
 * Consulta el estado de permiso de llamada de WhatsApp para un contacto.
 * @param {string} waPhoneId ID de la línea de WhatsApp Business
 * @param {string} toNumber Teléfono / wa_id del cliente
 * @returns {Promise<Object>} Estado de permiso y acciones disponibles
 */
export async function hasWhatsappCallPermission(waPhoneId, toNumber) {
    try {
        const response = await axios.get(
            `${REACT_APP_API}/integrations/hasWhatsappCallPermission`,
            { params: { waPhoneId, toNumber } }
        )
        return response.data?.data
    } catch (error) {
        console.error('Error al consultar permiso de llamada de WhatsApp', error)
        throw error
    }
}

/**
 * Envía una solicitud de permiso de llamada al contacto.
 * @param {Object} params
 * @param {string} params.waPhoneId ID de la línea de WhatsApp Business
 * @param {string} params.toNumber Teléfono / wa_id del cliente
 * @param {string} params.leadId Lead asociado
 * @param {string} params.clientId Cliente asociado
 * @param {string} [params.textBody] Texto opcional del mensaje
 * @returns {Promise<Object>}
 */
export async function sendWhatsappCallRequestPermission({ waPhoneId, toNumber, leadId, clientId, textBody }) {
    try {
        const response = await axios.post(
            `${REACT_APP_API}/integrations/whatsappCallRequestPermission`,
            { waPhoneId, toNumber, leadId, clientId, textBody }
        )
        return response.data?.data
    } catch (error) {
        console.error('Error al enviar solicitud de permiso de llamada', error)
        throw error
    }
}
